import { GetEventsResponse, Item } from 'components/hmilib/interfaces';
import { fetchData } from './index';

export const GetEvents = (
    sortCol: string,
    sortUp: boolean,
    filterItems: string,
    selectPage: number,
    limit: number
): Promise<GetEventsResponse> => {
    const requestBody = {
        sortCol: sortCol || '',
        sortUp: sortUp,
        filterItems: filterItems || '',
        selectPage: selectPage >= 0 ? selectPage : 0,
        limit: limit || 0
    };

    return fetchData('/Event/GetEvents', 'POST', requestBody)
        .then((response) => {
            if (!response.ok) throw Error(response.statusText);
            return response.json();
        })
        .catch((error) => {
            console.error('error', error);
            throw error;
        });
};

export const AddEvents = (items: Array<Item>): Promise<any> => {
    const options: RequestInit = { cache: 'no-cache' };

    return fetchData('/Event/AddEvents', 'POST', items, options)
        .then((response) => {
            if (!response.ok) throw Error(response.statusText);
            // return response.json();
            return true;
        })
        .catch((error) => {
            console.error('error', error);
            throw error;
        });
};

export const GetListCol = (NameCol: string): Promise<Array<string>> => {
    return fetchData(`/Event/GetListCol?NameCol=${NameCol}`, 'GET')
        .then((response) => {
            return response.json();
        })
        .catch((error) => {
            console.error('error', error);
            throw error;
        });
};
